var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
import { Falcon } from 'modules/macro';
import { useGeneratedId } from 'modules/utils';
import { useFileDragDetector } from '../hooks/useFileDragDetector';
import { useProgressWarning } from '../hooks/useProgressWarning';
import { Container, Input, StickyContent, BadgeContainer } from '../styled';
export const Dropzone = forwardRef((props, forwardedRef) => {
    const { id: controlledId, label, className, description, progress = -1 } = props, restProps = __rest(props, ["id", "label", "className", "description", "progress"]);
    const { isDragging } = useFileDragDetector();
    const autoId = useGeneratedId('dropzone');
    const id = controlledId || autoId;
    const describedBy = description ? `${id}-description` : undefined;
    const isLoading = progress >= 0 && progress <= 1;
    useProgressWarning(progress);
    return (<Container className={className} $isDragging={isDragging}>
      <Input id={id} ref={forwardedRef} type="file" aria-describedby={describedBy} disabled={isLoading} {...restProps}/>
      <StickyContent>
        <BadgeContainer>
          <Falcon icon="file-arrow-up" $size={32} $color="swatches.blue.600" sourceConfig={{ family: 'classic', style: 'solid' }}/>
        </BadgeContainer>
        <Box flexDirection="column">
          {label && (<Typography as="label" htmlFor={id} $fontWeight="semibold" $appearance="200">
              {label}
            </Typography>)}
          {description && !isLoading && (<Typography id={describedBy} $fontSize="small" $appearance="100">
              {description}
            </Typography>)}
        </Box>
      </StickyContent>
    </Container>);
});
Dropzone.displayName = 'Dropzone';
